export default __webpack_public_path__ + "static/media/lyubo_m.b0cbe51d.jpg";